const footLinks = [
  { label: "阅读体验", href: "#features" },
  { label: "热门韩漫", href: "#showcase" },
  { label: "体验预览", href: "#reader" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

const footCats = ["恋爱韩漫", "奇幻韩漫", "都市韩漫", "动作韩漫", "悬疑韩漫", "校园韩漫"];

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-16 md:px-6">
        <div className="mb-12 flex flex-col items-center gap-6 rounded-2xl bg-background-800 px-6 py-10 text-center md:py-12">
          <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
            现在就开启清爽的韩漫阅读之旅
          </h2>
          <p className="max-w-xl text-sm leading-relaxed text-background-400">
            无弹窗、高清、极速加载，翻页缩放顺手自如。韩漫在线的海量连载韩漫等你来发现。
          </p>
          <a
            href="#showcase"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
          >
            免费开始阅读
          </a>
        </div>

        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-open-line text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">韩漫在线</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-400">
              为纯粹阅读而生的韩漫在线阅读平台，无弹窗、高清、极速加载，翻页缩放顺手自如。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {footLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-400 transition-colors hover:text-primary-400">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">题材分类</h3>
            <ul className="mt-4 space-y-2.5">
              {footCats.map((c) => (
                <li key={c}>
                  <a href="#categories" className="text-sm text-background-400 transition-colors hover:text-primary-400">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">联系我们</h3>
            <ul className="mt-4 space-y-3 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                support@hanmanzaixian.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-400"></i>
                客服在线时间 09:00 - 22:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-chat-3-line text-primary-400"></i>
                欢迎反馈与建议
              </li>
            </ul>
            <div className="mt-4 flex gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line"].map((ic) => (
                <a
                  key={ic}
                  href="#top"
                  aria-label="社交平台"
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-800 text-background-300 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={ic}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-500">
            © {new Date().getFullYear()} 韩漫在线 · 为纯粹阅读而生
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#about" className="transition-colors hover:text-primary-400">关于我们</a>
            <a href="#faq" className="transition-colors hover:text-primary-400">帮助中心</a>
            <span>无弹窗 · 高清 · 极速</span>
          </div>
        </div>
      </div>
    </footer>
  );
}